import { Controller } from '@hotwired/stimulus'
import { Client } from '@searchspring/snap-client'

let clientInstance: Client | null = null

export default class BaseSearchSpringController extends Controller {
  get client(): Client {
    if (!clientInstance) {
      const siteId = document
        .querySelector('meta[name="searchspring-site-id"]')
        ?.getAttribute('content')

      if (!siteId) throw new Error('SearchSpring site ID is not configured.')

      clientInstance = new Client({
        siteId,
      })
    }
    return clientInstance
  }

  injectHtmlIntoTarget(target: Element, html: string | null) {
    if (!html || html.trim().length === 0) return

    const wrapper = document.createElement('div')
    wrapper.innerHTML = html
    const newHtml = wrapper.firstElementChild?.innerHTML ?? html

    // Fade out old content
    target.classList.add('content-updating')
    target.classList.remove('content-ready')

    // Use requestAnimationFrame to batch the DOM write
    requestAnimationFrame(() => {
      target.innerHTML = newHtml

      // Fade back in on next frame
      requestAnimationFrame(() => {
        target.classList.remove('content-updating')
        target.classList.add('content-ready')
      })
    })

    return target.innerHTML
  }
}
